import axiosIns from '@axios'

import type { ColumnType } from '@/store/helpers/default-values'

const $http = axiosIns

export const DIVISION_SETTINGS_BASE_URL = '/division-settings'

export type DivisionDefinition = {
  code: string
  label: string
}

export type ColumnDefinition = {
  key: string
  title: string
}

export type ColumnTypeDefinition = {
  code: ColumnType
  label: string
  columns: ColumnDefinition[]
}

export type DivisionColumnSetting = {
  id: number
  division: string
  division_label: string
  column_type: ColumnType
  column_type_label: string
  column_keys: string[]
  available_columns?: ColumnDefinition[]
}

export type DivisionColumnSettingUpdatePayload = {
  column_keys: string[]
}

export type DivisionSettingsFullSettingsResponse = {
  divisions: DivisionDefinition[]
  column_types: ColumnTypeDefinition[]
  settings: DivisionColumnSetting[]
}

export type DivisionColumnSettingsListResponse =
  | DivisionColumnSetting[]
  | { results: DivisionColumnSetting[] }

export type UserAvailableColumnsResponse = {
  divisions: DivisionDefinition[]
  column_keys: Partial<Record<ColumnType, string[]>>
  columns: Partial<Record<ColumnType, ColumnDefinition[]>>
}

export const $divisionSettingsFullSettings = async () => {
  const { data } = await $http.get<DivisionSettingsFullSettingsResponse>(
    `${DIVISION_SETTINGS_BASE_URL}/full-settings/`,
  )

  return data
}

export const $divisionColumnSettingsList = async () => {
  const { data } = await $http.get<DivisionColumnSettingsListResponse>(
    `${DIVISION_SETTINGS_BASE_URL}/settings/`,
  )

  return Array.isArray(data) ? data : data.results
}

export const $divisionColumnSettingUpdate = async (
  id: number,
  payload: DivisionColumnSettingUpdatePayload,
) => {
  const { data } = await $http.patch<DivisionColumnSetting>(
    `${DIVISION_SETTINGS_BASE_URL}/settings/${id}/`,
    payload,
  )

  return data
}

export const $userAvailableColumns = async (
  columnTypes?: ColumnType[],
) => {
  const { data } = await $http.get<UserAvailableColumnsResponse>(
    `${DIVISION_SETTINGS_BASE_URL}/user-columns/`,
    {
      params: columnTypes?.length
        ? { column_types: columnTypes.join(',') }
        : undefined,
    },
  )

  return data
}
